import React from 'react';
import { useLanguage } from '../lib/LanguageContext';
export function ServicesSection() {
  const {
    t
  } = useLanguage();
  return <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-12" data-id="element-162">
      {t.services.map((service, index) => <div key={index} className="border border-[#c9a84c] p-8 bg-[#111111] transition-colors duration-300 hover:bg-[#1a1a1a]" data-id="element-163">
          <h3 className="font-['Playfair_Display'] text-xl font-bold text-white mb-4 tracking-wider" data-id="element-164">
            {service.title}
          </h3>
          <p className="text-[#f5f0e8] text-lg leading-relaxed" data-id="element-165">
            {service.description}
          </p>
        </div>)}
    </div>;
}